import { FC } from 'react';
import { CardLanding } from 'src/presentations/components/molecules/card/CardLanding';
import { formatDate } from 'src/utils/date';
import IconCalender from 'src/assets/images/icons/filter-calendar.svg';
import IconTrash from 'src/assets/images/icons/trash.svg';

import { IReportCardProps } from './types';

export const ReportCard: FC<IReportCardProps> = ({ item, rootPath = '/analytics', onDelete }) => (
  <CardLanding
    title={item?.name?.length === 0 ? 'Unnamed Report' : item?.name}
    info={item?.description?.length === 0 ? '' : item?.description}
    path={`${rootPath}?report=${item?.hashedFilters}&id=${item?.id}`}
    actions={
      onDelete ? (
        <button type='button' className='w-[28px] h-[28px] rounded-6 border border-neutral-40 flex items-center justify-center' onClick={onDelete}>
          <img src={IconTrash} alt='icon-trash' className='w-16 h-16' />
        </button>
      ) : undefined
    }
  >
    {item?.updateDate && (
      <div className='flex items-center'>
        <img src={IconCalender} alt='icon-calender' className='w-14 h-14 mr-2' />
        <div className='text-12 text-[#808080] font-normal ml-2'>{`Last Updated on ${formatDate(new Date(item?.updateDate))}`}</div>
      </div>
    )}
  </CardLanding>
);
